import styled from 'styled-components';
import { Z_INDEX_HIGH } from '@mews-ui/theme';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken } from '@optimus-web/common';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/local-tokens';

const COLLAPSED_WIDTH = 72;
const EXPANDED_WIDTH = 300;

export const SideMenuContainer = styled.div<{ collapsed: boolean }>`
    background-color: ${getToken(TokenName.BACKGROUND_STATIC_FLAT)};
    box-shadow: ${getToken(TokenName.SHADOW_200)};
    width: ${({ collapsed }) => (collapsed ? `${COLLAPSED_WIDTH}px` : `${EXPANDED_WIDTH}px`)};
    display: flex;
    flex-direction: column;
    height: 100%;
    border-right: ${getToken(TokenName.BORDER_WIDTH_100)}px solid ${getToken(TokenName.BORDER_STATIC_SECONDARY)};
    position: relative;
`;

export const SideMenuTopCard = styled.div`
    border-bottom: ${getToken(TokenName.BORDER_WIDTH_100)}px solid ${getToken(TokenName.BORDER_STATIC_SECONDARY)};
    background-color: ${getToken(TokenName.BACKGROUND_STATIC_FLAT)};
    z-index: ${Z_INDEX_HIGH};
`;

export const SideMenuList = styled.div<{ hasScrollBar: boolean; collapsed: boolean }>`
    flex-grow: 1;
    overflow-y: auto;
    padding: ${getToken(TokenName.SPACING_400)}px
        ${({ hasScrollBar, collapsed, theme }) =>
            hasScrollBar && collapsed ? 0 : `${getToken(TokenName.SPACING_200)({ theme })}px`}
        ${getToken(TokenName.SPACING_400)}px ${getToken(TokenName.SPACING_200)}px;
    background-color: ${getToken(TokenName.BACKGROUND_STATIC_FLAT)};
    z-index: ${Z_INDEX_HIGH};
`;

export const SideMenuBottomCard = styled.div<{ hasScrollBar: boolean }>`
    border-top: ${getToken(TokenName.BORDER_WIDTH_100)}px solid ${getToken(TokenName.BORDER_STATIC_SECONDARY)};
    ${({ hasScrollBar, theme }) =>
        hasScrollBar
            ? `background-color: ${getToken(TokenName.BACKGROUND_STATIC_RAISED)({ theme })};`
            : `background-color: ${getToken(TokenName.BACKGROUND_STATIC_FLAT)({ theme })};`}
    z-index: ${Z_INDEX_HIGH};
`;

export const SideMenuPanelContainer = styled.div<{ active?: boolean; collapsed?: boolean }>`
    width: ${EXPANDED_WIDTH}px;
    position: absolute;
    top: 0;
    left: ${({ collapsed }) => (collapsed ? `calc(${COLLAPSED_WIDTH}px - ${EXPANDED_WIDTH}px)` : '0')};
    border-right: ${getToken(TokenName.BORDER_WIDTH_100)}px solid ${getToken(TokenName.BORDER_STATIC_SECONDARY)};
    height: 100%;
    background-color: ${getToken(TokenName.BACKGROUND_STATIC_FLAT)};
    overflow-y: auto;
    transition: transform ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};
    transform: translateX(${({ active }) => (active ? '100%' : '0')});
`;

export const SideMenuPanelContent = styled.div`
    padding: ${getToken(TokenName.SPACING_300)}px ${getToken(TokenName.SPACING_200)}px;
`;
